/* global bocAmchart, AmCharts */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetCategoriesWaterfall = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetCategoriesWaterfall(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data for the data with categories,
 * rather than time data. Several assumptions are used,
 * first is that series label has the terms set in label in both languages separated by underscore
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetCategoriesWaterfall = function (data, dataLoader, chart) {
    var output,
        revisedText,
        categoryTerm,
        seriesTerm,
        seriesDetails,
        series,
        categorySet,
        terms,
        category,
        seriesSet,
        i;

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running postProcessValetCategoriesWaterfall, inputs:",
            data,
            "Graphs: ",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    output = [];
    revisedText = bocAmchart.getRevisedText();

    categoryTerm = 'category';

    if (chart.bocSettings.args.hasOwnProperty('categoryterm')) {
        categoryTerm = chart.bocSettings.args.categoryterm;
    }
    seriesTerm = 'series';
    if (chart.bocSettings.args.hasOwnProperty('seriesterm')) {
        seriesTerm = chart.bocSettings.args.seriesterm;
    }

    // Setting "named array" to avoid multiple loops through data
    categorySet = [];
    seriesSet = [];

    // Fill the terms data from series names before it is pushed as a feature in webmart and valet
    data = bocAmchart.termsPolyfill(data, categoryTerm, seriesTerm, chart.bocSettings);

    // Loop through all the observations, get all the series
    // Later observations containing same series will overwrite previous data

    data.observations.forEach(function (obs) {
        // Looping through series, and find an observation for each of them
        for (series in data.seriesDetail) {

            // property is either date or series name, ignoring the date field for now
            if (data.seriesDetail.hasOwnProperty(series) && obs.hasOwnProperty(series)) {
                seriesDetails = data.seriesDetail[series];
                if (seriesDetails.hasOwnProperty('terms')) {
                    terms = seriesDetails.terms;
                    if (terms.hasOwnProperty(categoryTerm) && terms.hasOwnProperty(seriesTerm)) {

                        // This value point belongs to series that has category term defined
                        if (!categorySet.hasOwnProperty(terms[categoryTerm])) {
                            categorySet[terms[categoryTerm]] = {};
                        }

                        // This value point belongs to series that has category term defined
                        if (seriesSet.indexOf(terms[seriesTerm]) === -1) {
                            seriesSet.push(terms[seriesTerm]);
                        }

                        categorySet[terms[categoryTerm]][terms[seriesTerm]] = obs[series].v;
                        if (obs[series].hasOwnProperty('r') && obs[series].r === 1) {
                            categorySet[terms[categoryTerm]][terms[seriesTerm] + '_R'] = revisedText;
                        }
                        if (terms.hasOwnProperty('term2')) {
                            categorySet[terms[categoryTerm]][terms[seriesTerm] + '_term2'] = terms['term2'];
                        }
                        if (terms.hasOwnProperty('term3')) {
                            categorySet[terms[categoryTerm]][terms[seriesTerm] + '_term3'] = terms['term3'];
                        }
                    }
                }
            }
        }
    });

    for (category in categorySet) {
        categorySet[category]['category'] = category;
        output.push(categorySet[category]);
    }

    // Add the column graph for each series term found
    i = 0;
    chart.graphs = [];

    chart.graphs.push({
        "id": "g" + i,
        "closeField": "close",
        "openField": "open",
        "colorField": "color",
        "lineColorField": "color",
        "type": "candlestick",
        "fillAlphas": 0.8,
        "balloonText": "<span style='font-size: 14px;'>"
            + "[[formatted]] "
            + (chart.bocSettings.args.chartunit ? chart.bocSettings.args.chartunit : '')
            + " - [[category]]</span>",
        "title": seriesSet[0]

    });

    var previous = 0;
    chart.trendLines = [];

    output.forEach(function(dataPoint, idx, array) {
        dataPoint.formatted = AmCharts.formatNumber(
            parseFloat(dataPoint[seriesSet[0]]),
            {
                precision: chart.precision,
                decimalSeparator: chart.decimalSeparator,
                thousandsSeparator: chart.thousandsSeparator
            },
            2
        );
        if (idx === 0 || idx === array.length - 1) {
            dataPoint.open = 0;
            dataPoint.close = parseFloat(dataPoint[seriesSet[0]]);
            dataPoint.color = "#0EB663";
        } else {
            dataPoint.open = previous;
            dataPoint.close = dataPoint.open + parseFloat(dataPoint[seriesSet[0]]);
            if (parseFloat(dataPoint[seriesSet[0]]) > 0) {
                dataPoint.color = "#0069EB";
            } else {
                dataPoint.color = "#B92020";
            }
        }

        if (idx > 0) {
            chart.trendLines.push({
                "dashLength": 3,
                "finalCategory": dataPoint['category'],
                "finalValue": previous,
                "initialCategory": array[idx-1]['category'],
                "initialValue": previous,
                "lineColor": "#555555",
                "lineThickness": 1
            });
        }
        previous = dataPoint.close;
    });


    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data for the titles from group:",
            data,
            "Chart:",
            bocAmchart.debugClone(chart)
        );
    }

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after postProcessValetCategoriesWaterfall:",
            output,
            "Graphs:",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    return output;
};
